import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { SplashScene } from "./SplashScene";

export class CalendarButton extends Phaser.GameObjects.Container {

    private btnImage: Phaser.GameObjects.Image;
    private label: Phaser.GameObjects.Text;
    private checkIcon: Phaser.GameObjects.Image;
    private lock: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        
        super(scene);

        this.x = x;
        this.y = y;

        this.btnImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_1");
        this.btnImage.setOrigin(.53, .47);
        this.btnImage.setInteractive({useHandCursor: true});
        this.btnImage.on("pointerup", this.onDayUp, this);
        this.addAt(this.btnImage);

        this.label = new Phaser.GameObjects.Text(this.scene, -4, 0, "0", {fontFamily: "OpenSans-CondLight", fontSize: "52px", color: "#7C5D46"});
        this.label.setOrigin(.5);
        this.add(this.label);

        this.lock = new Phaser.GameObjects.Image(this.scene, -2, -5, "texture_atlas_1", "lock_calendar");
        this.lock.setScale(1.25);
        this.lock.visible = false;
        this.add(this.lock);

        this.checkIcon = new Phaser.GameObjects.Image(this.scene, 23, 23, "texture_atlas_1", "check_icon");
        this.checkIcon.setScale(1.3);
        this.add(this.checkIcon);
    }

    public setDay(day: number): void {

        this.label.setText(day.toString());
    }

    public markToday(): void {

        this.scale = 1.1;
        this.btnImage.setFrame("btn_2");

        this.label.setColor("#55401d");
        this.label.setFontSize(51);

        this.scene.tweens.add({
            targets: this,
            scaleX: 1.2,
            scaleY: 1.2,
            duration: 1000,
            ease: Phaser.Math.Easing.Cubic.InOut,
            yoyo: true,
            repeat: -1
        });
    }

    public unMarkToday(): void {
            
        this.scale = 1;
        this.btnImage.setFrame("btn_1");

        this.label.setColor("#5b6459");
        this.label.setFontSize(42);

        // parar el tween
        this.scene.tweens.killTweensOf(this);
    }

    public markCurrentMonth(): void {

        this.label.alpha = 1;
    }

    public unMarkCurrentMonth(): void {

        this.label.alpha = .5;
    }

    public markFutureDay(): void {

        this.btnImage.alpha = .5;
        this.btnImage.disableInteractive();
        this.label.visible = false;
        this.lock.visible = true;

        this.checkIcon.visible = false;
    }

    public unMarkFutureDay(): void {

        this.btnImage.alpha = 1;
        this.btnImage.setInteractive({useHandCursor: true});

        const levelIndex = GameManager.getLevelIndex(JSON.parse(this.name));
        const levelID = GameVars.boardsData[levelIndex].id;

        this.label.visible = true;
        this.lock.visible = false;

        // MIRAR SI YA HA SIDO JUGADO
        this.checkIcon.visible = false;

        for (const cat in GameVars.gameData.categoriesData) {
            if (GameVars.gameData.categoriesData.hasOwnProperty(cat)) {
                // Buscar en la lista de niveles de cada categoría
                if (GameVars.gameData.categoriesData[cat].levelsData.some(level => level.id === levelID && level.time > 0)) {
                    this.checkIcon.visible = true;
                    this.scene.tweens.killTweensOf(this);
                    break;
                }
            }
        }
    }

    private onDayUp(): void {

        if (SplashScene.currentInstance.categoryLayer !== null || SplashScene.currentInstance.firstSessionLayer !== null ||  SplashScene.currentInstance.brandingLayer !== null || SplashScene.currentInstance.transitioning || SplashScene.currentInstance.settingsLayer !== null) {
            return;
        }

        const callbacks = {
            adFinished: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.unmute();
                }
                GameManager.onDaySelected(JSON.parse(this.name)); 
            },
            adError: (error, errorData) =>  {
                GameManager.onDaySelected(JSON.parse(this.name)); 
            },
            adStarted: () => {
                if (!GameVars.gameData.muted) {
                    AudioManager.mute();
                }
            }
        };

        const w = <any> window;
        w.CrazyGames.SDK.ad.requestAd("midgame", callbacks);

        AudioManager.playSound("btn_press");
    }
}
